(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["free-shipping-progress"] && !Shopify.designMode) return;
  try {
    (function() {
    function formatShippingMoney(cents, currency) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: currency
        }).format(cents / 100);
      } catch (error) {
        return currency + ' ' + (cents / 100).toFixed(2);
      }
    }

    function updateShippingProgress(root) {
      var threshold = Number(root.dataset.threshold);
      var total = Number(root.dataset.total);
      var currency = root.dataset.currency;
      var thresholdCurrency = root.dataset.thresholdCurrency;
      var sameCurrency = currency === thresholdCurrency;
      root.hidden = root.dataset.requiresShipping !== 'true' || !(threshold > 0);
      if (root.hidden) return;

      if (!sameCurrency) {
        var shopifyCurrency = window.Shopify && window.Shopify.currency;
        var rate = shopifyCurrency && Number(shopifyCurrency.rate);
        if (thresholdCurrency === root.dataset.shopCurrency &&
            shopifyCurrency && shopifyCurrency.active === currency &&
            Number.isFinite(rate) && rate > 0) {
          threshold = Math.ceil(threshold * rate - 0.0000001);
          sameCurrency = true;
        }
      }

      var message = root.querySelector('[data-shipping-message]');
      var track = root.querySelector('[data-shipping-track]');
      var fill = root.querySelector('[data-shipping-fill]');
      if (!message || !track || !fill) return;
      track.hidden = !sameCurrency;

      if (!sameCurrency) {
        message.textContent = root.dataset.goalTemplate.replace('__amount__',
          formatShippingMoney(Number(root.dataset.threshold), thresholdCurrency));
        return;
      }

      var remaining = Math.max(threshold - total, 0);
      var percent = Math.min(Math.max(total / threshold * 100, 0), 100);
      message.textContent = remaining === 0 ? root.dataset.reachedMessage :
        root.dataset.remainingTemplate.replace('__amount__', formatShippingMoney(remaining, currency));
      track.setAttribute('aria-valuenow', String(Math.round(percent)));
      fill.style.width = percent + '%';
      root.dataset.calculatedThreshold = String(threshold);
      root.dataset.remaining = String(remaining);
    }

    function updateAllShippingProgress(scope) {
      (scope || document).querySelectorAll('[data-free-shipping-progress]').forEach(updateShippingProgress);
    }

    document.addEventListener('cart:rendered', function(event) {
      updateAllShippingProgress(event.detail && event.detail.form);
    });
    document.addEventListener('shopify:section:load', function(event) {
      updateAllShippingProgress(event.target);
    });
    window.addEventListener('pageshow', function() { updateAllShippingProgress(); });
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { updateAllShippingProgress(); });
    } else {
      updateAllShippingProgress();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
